import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, catchError, Observable } from 'rxjs'
@Injectable({
  providedIn: 'root',
})
export class RepServices extends BehaviorSubject<any[]> {
  private data: any[] = []
  constructor(private _http: HttpClient) {
    super([])
  }
  // take: optional row cap so a grid can paint a first page before the full
  // list arrives. Omit for every record.
  getNportSubmissionTypeList(take?: number): Observable<any> {
    const query = take ? `?take=${take}` : ''
    return this._http
      .get<any[]>(`/api/Clients/RetrieveAllclients${query}`)
      .pipe(catchError(this.handleError))
  }
  getReasonTypeList(): Observable<any> {
    return this._http
      .get<any[]>(`/api/Clients/getReasonList`)
      .pipe(catchError(this.handleError))
  }
  getpendingbranches(data: any): Observable<any> {
    return this._http
      .post<any[]>(`/api/Rep/GetPendingBranch`, data)
      .pipe(catchError(this.handleError))
  }
  CheckdatabasedOffTaxId(data: any): Observable<any> {
    return this._http
      .post<any[]>(`/api/TaxIDMask/CheckTxd`, data)
      .pipe(catchError(this.handleError))
  }
  /** Soft duplicate check for 529 / UTMA-UGMA: matches Client.SecondaryTaxId. */
  CheckSecondaryTaxId(data: { TaxId: string; ClientTypeID: number; ClientId?: number }): Observable<any> {
    return this._http
      .post<any[]>(`/api/TaxIDMask/CheckSecondaryTxd`, data)
      .pipe(catchError(this.handleError))
  }
  CheckTxdreturnstrings(data: any): Observable<any> {
    return this._http
      .post<any[]>(`/api/TaxIDMask/CheckTxdreturnstring`, data)
      .pipe(catchError(this.handleError))
  }
  getreplist() {
    return this._http.get(`/api/Rep/GetReplist`)
  }
  RemoveClientMakeInActive(data: any) {
    return this._http.post<any[]>(`/api/Clients/ClientInActive`, data)
    .pipe(catchError(this.handleError))
  }
  getClienttypeList() {
    return this._http.get(`/api/Rep/GetClientTypelists`)
  }
  getrepBranchlist(b: any): Observable<object[]> {
    return this._http
      .get<any[]>(`/api/Rep/GetRepBranchList`)
      .pipe(catchError(this.handleError))
  }
  getpendingreps(data: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Rep/GetPendingRep`, data)
      .pipe(catchError(this.handleError))
  }
  isValidState(repId: number, clientId: number): Observable<boolean> {
    return this._http
      .post<boolean>(`/api/Rep/IsValidState`, {
        repId: repId,
        clientId: clientId,
      })
      .pipe(catchError(this.handleError))
  }
  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
